import React from "react"

const HamiltonMeta = {
    header: {
        title: "Hamilton Airport Shuttle Service To/From Toronto Pearson",
        subtitle: "Affordable, reliable, non-stop daily bus service",
        description: "Looking for a reliable and affordable airport shuttle from Hamilton International Airport (YHM) to Toronto Pearson International Airport (YYZ)? Landline offers comfortable, hassle-free transportation with multiple daily departures, ensuring you get to and from your flights on time. Our premium motorcoaches provide spacious seating, free onboard Wi-Fi, in-seat power outlets to charge your devices, an onboard bathroom for your convenience, and a stress-free alternative to driving or paying expensive YYZ parking fees.",
        book: false
    },
    seo: {
        title: "Landline Hamilton Airport Shuttle Service To/From Toronto Pearson",
        description: ""
    }
}

const WaterlooMeta = {
    header: {
        title: "Kitchener-Waterloo Airport Shuttle Service To/From Toronto Pearson",
        subtitle: "Affordable, reliable, non-stop daily bus service",
        description: "Looking for a reliable and affordable airport shuttle from Region of Waterloo International Airport (YKF) to Toronto Pearson International Airport (YYZ)? Landline offers comfortable, hassle-free transportation with multiple daily departures, ensuring you get to and from your flights on time. Our premium motorcoaches provide spacious seating, free onboard Wi-Fi, in-seat power outlets to charge your devices, an onboard bathroom for your convenience, and a stress-free alternative to driving or paying expensive YYZ parking fees.",
        book: false
    },
    seo: {
        title: "Landline Kitchener-Waterloo Airport Shuttle Service To/From Toronto Pearson",
        description: ""
    }
}

const HamiltonFares = {
    titles: ["Location", "Adults", <p>Child<br/><small>(12 & Under)</small></p>, <p>Penguin Perks<br/><small>(Silver Tier & Above)</small></p>],
    data: [
        ["Hamilton International Airport (YHM)", "$49 CAD", "FREE", "$44 CAD"],
    ],
}

const WaterlooFares = {
    titles: ["Location", "Adults", <p>Child<br/><small>(12 & Under)</small></p>, <p>Penguin Perks<br/><small>(Silver Tier & Above)</small></p>],
    data: [
        ["Region of Waterloo International Airport (YKF)", "$49 CAD", "FREE", "$44 CAD"],
    ],
}

export {
    HamiltonMeta,
    WaterlooMeta,
    HamiltonFares,
    WaterlooFares
}